var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"color":_vm.color,"small":"","size":_vm.size}},[_c('v-icon',{attrs:{"color":"white","size":_vm.size / 1.75}},[_vm._v(_vm._s(_vm.channel.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }